import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import EventEmitter, {
  DID_MOUNT_COMPONENT,
} from '../../../../../../helpers/EventEmitter'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  handleIconDownload,
} from '../../../helper'
import classes from '../../../index.module.scss'
import { selectDataViewByTrend } from '../store/slice'
import Loss from './Loss'
import Quality from './Quality'
import Term from './Term'
import TopSector from './TopSector'
import { TERM_DATA, TREND_QUALITY_DATA } from './constant'

const Trend = ({ id, isDynamicReport, check, year, isDownloadComponent }) => {
  const dataByTrend = useSelector(selectDataViewByTrend)

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  const chart = []
  if (!isDynamicReport) {
    chart.push(...[1, 2, 3, 4, 5])
  } else {
    if (TREND_QUALITY_DATA.some(({ value }) => check.includes(value))) {
      chart.push(1)
    }
    if (check.includes('top3Sector')) {
      chart.push(2)
    }
    if (TERM_DATA.some(({ value }) => check.includes(value))) {
      chart.push(3)
    }
    if (check.includes('lossToNpl')) {
      chart.push(4)
    }
    if (check.includes('lossToTotalLoan')) {
      chart.push(5)
    }
  }

  const isHasOnlyTop3Sector = chart.includes(2) && chart.length === 1

  useEffect(() => {
    if (isHasOnlyTop3Sector) {
      EventEmitter.dispatch(DID_MOUNT_COMPONENT)
    }
  }, [])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const isDynamicOrJPG = isDynamicReport || isDownloadComponent

  return (
    <div
      style={{
        height: getStyleHeightContainer(
          isDynamicOrJPG,
          isNoData,
          'fit-content',
        ),
      }}
      className={`${!isDynamicOrJPG ? 'dFlex' : 'flexColumn'} ${
        classes.loanBookTrendContainer
      }`}
    >
      {chart.includes(1) && (
        <div
          style={{
            height: isDynamicOrJPG ? 200 : '100%',
            width: !isDynamicOrJPG ? `calc(100% / 3)` : '100%',
          }}
          className={classes.pr12}
        >
          <Quality id={id} check={check} isDynamicReport={isDynamicOrJPG} />
        </div>
      )}
      {(chart.includes(2) || chart.includes(3)) && (
        <div
          style={{
            height: isDynamicOrJPG
              ? !chart.includes(3)
                ? 'fit-content'
                : !chart.includes(2)
                ? 250
                : 420
              : '100%',
            width: !isDynamicOrJPG ? `calc(100% / 3)` : '100%',
            paddingTop: isDynamicOrJPG ? 20 : undefined,
          }}
          className={`flexColumn ${classes.pr4} ${classes.pl4}`}
        >
          {chart.includes(2) && (
            <TopSector id={id} year={year} isDynamicReport={isDynamicOrJPG} />
          )}
          {chart.includes(3) && (
            <div className="h100">
              <Term id={id} check={check} isDynamicReport={isDynamicOrJPG} />
            </div>
          )}
        </div>
      )}
      {(chart.includes(4) || chart.includes(5)) && (
        <div
          style={{
            height: isDynamicOrJPG ? 300 : '100%',
            width: !isDynamicOrJPG ? `calc(100% / 3)` : '100%',
            paddingTop: isDynamicOrJPG ? 20 : undefined,
          }}
          className={classes.pl12}
        >
          <Loss id={id} chart={chart} isDynamicReport={isDynamicOrJPG} />
        </div>
      )}
    </div>
  )
}

export default Trend
